import React from "react";
import {
  Box,
  Typography,
  LinearProgress,
  Stack,
  Container,
  Grid,
} from "@mui/material";
import volvo from "../assets/volvo-crane.jpg";
import { motion } from "framer-motion";

const SkillBar_Section = () => {
  const SkillBar = ({ label, value }) => {
    return (
      <Box mb={3}>
        <Typography
          variant="subtitle1"
          sx={{ color: "#fff", fontWeight: 600, mb: 1 }}
        >
          {label} — {value}%
        </Typography>

        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: "rgba(255,255,255,0.2)",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#ff3333", // your theme red
            },
          }}
        />
      </Box>
    );
  };
  return (
    <div>
      <Box
        sx={{
          backgroundColor: "#260d0d",
          color: "#fff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ paddingTop: "60px", paddingBottom: "60px" }}
            >
              <motion.div
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <Box flex={1} pr={{ md: 8 }}>
                  <Typography
                    variant="subtitle2"
                    className="paraAfter-line"
                    sx={{ marginBottom: "20px" }}
                  >
                    RECENT PROJECTS
                  </Typography>

                  <Typography
                    variant="h1"
                    className="headPara"
                    sx={{
                      fontWeight: 700,
                      mb: 3,
                      lineHeight: 1.2,
                      color: "#fff",
                    }}
                  >
                   Building Today for <br /> Stronger Tomorrow
                  </Typography>

                  <Typography variant="body1" sx={{ opacity: 0.9, mb: 4 }}>
                  We supply high-quality construction materials and end-to-end logistics that power infrastructure, highways, and large-scale developments across the state. Our operations are built on reliability, scale, and strict quality control.
                  </Typography>

                  <Typography variant="body1" sx={{ marginBottom: "40px" }}>
                  From sand mining and aggregate processing to brick supply and bulk transportation, we support projects that demand consistency, speed, and compliance
                  </Typography>

                  {/* SKILLS */}
                  <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                  >
                    <Stack spacing={2}>
                      <SkillBar label="Material Supply & Logistics" value={80} />
                      <SkillBar label="Mining & Processing" value={65} />
                      <SkillBar label="Infrastructure & Urban Development" value={90} />
                    </Stack>
                  </motion.div>
                </Box>
              </motion.div>
            </Grid>
            {/* RIGHT CONTENT */}
            <Grid size={{ xs: 12, md: 6 }}>
              <motion.div
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <Box
                  sx={{
                    flex: 1,
                    display: { xs: "none", md: "block" },
                    height: "100%",
                    // position:'relative'
                  }}
                >
                  <Box
                    sx={{
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundImage: `url(${volvo})`,
                      width: "calc(100% - 51%)",
                      // height: "calc(100vh - 21vh)",
                      height: "95vh",
                      position: "absolute",
                    }}
                  ></Box>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default SkillBar_Section;
